/* eslint-disable no-nested-ternary */
import { Circle } from '../../assets/icons/circle'
import { UserBlueIcon } from '../../assets/icons/userBlue'
import { colors } from '../../theme'
import {
  Container,
  Div,
  DivIcon,
  DivSeparate,
  Span,
  Td,
} from './HeaderCard.style'

type HeaderCardProps = {
  title: string
  status: string
  percentual: number | string
}

export function HeaderCard({ title, status, percentual }: HeaderCardProps) {
  return (
    <Container>
      <Span>
        <DivIcon>
          <UserBlueIcon />
        </DivIcon>
        <DivSeparate>
          <Div>{title.slice(0, 52)}</Div>
          <Div>
            <Td classification={status}>
              <span>
                <Circle
                  color={
                    status === 'EM_ALTA'
                      ? colors.secondary
                      : status === 'EM_BAIXA'
                      ? colors.errorText
                      : colors.system
                  }
                />
              </span>
              {status.replace('_', ' ').toLowerCase()}
            </Td>
            <Td classification={status}>({percentual}%)</Td>
          </Div>
        </DivSeparate>
      </Span>
    </Container>
  )
}
